import * as types from "../../mutationTypes";
import userService from "../../../services/userService";

const actions = {
  async getAll ({ state, dispatch, commit}, force) {
    if (!state.items || state.items.length === 0 || force) {
      dispatch('app/loadingDataEnable', 'users', {root: true});
      const users = await userService.findAll();
      await commit(types.USER_LIST, {
        items: users
      });
      dispatch('app/loadingDataDisable', 'users', {root: true});
    }
  },
  async create ({ dispatch, commit}, user) {
    try {
      let newUser = await userService.create(user);
      if (newUser) {
        await dispatch('getAll', true);
        return true;
      } else {
        return false;
      }
    } catch (ex) {
      console.error(ex);
    }
  },
  async update ({ dispatch, commit}, user) {
    try {
      let updatedUser = await userService.update(user);
      if (updatedUser) {
        await dispatch('getAll', true);
        return true;
      } else {
        return false;
      }
    } catch (ex) {
      console.error(ex);
    }
  },
  async activate ({ dispatch, commit}, id) {
    try {
      let response = await userService.activate(id);
      if (response.ok) {
        await dispatch('getAll', true);
        return true;
      } else {
        return false;
      }
    } catch (ex) {
      console.error(ex);
    }
  },
  async deactivate ({ dispatch, commit}, id) {
    try {
      let response = await userService.deactivate(id);
      if (response.ok) {
        await dispatch('getAll', true);
        return true;
      } else {
        return false;
      }
    } catch (ex) {
      console.error(ex);
    }
  },
  async delete ({dispatch, commit}, id) {
    let response = await userService.delete(id);
    if (response.ok) {
      dispatch('getAll', true);
      return true;
    } else {
      return false;
    }
  },
  async updateProfile ({dispatch, commit}, user) {
    try {
      let response = await userService.updateMe(user);
      if (response.ok) {
        return await dispatch('auth/fetchMe', null, { root: true })
      } else {
        return false;
      }
    } catch (ex) {
      console.error(ex);
    }
  },
  async myPasswordChange ({}, credentials) {
    try {
      let response = await userService.myPasswordChange(credentials);
      return response.ok;
    } catch (ex) {
      console.error(ex);
    }
  },
  async passwordChange ({}, data) {
    try {
      let response = await userService.passwordChange(data.userId, data.credentials);
      return response.ok;
    }
     catch (ex) {
      console.error(ex);
    }
  }
};

export default actions



// WEBPACK FOOTER //
// ./client/store/modules/user/userActions.js